import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useGetAllTendersQuery } from "../../redux/tenderApi";
import { HiDotsVertical } from "react-icons/hi";
import { useDebounce } from "use-debounce";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import dayjs from "dayjs";
import { useGetAllAuctionsQuery } from "../../redux/auctionApi";

export const formatToLongDate = (dateString) => {
  return dayjs(dateString).format("MMMM D, YYYY hh:mm A");
};

const Auctions = () => {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [debouncedSearch] = useDebounce(search, 1500);

  const handlePrev = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  const handleNext = () => {
    if (page < data?.totalPages) setPage((prev) => prev + 1);
  };

  const { data, error, isLoading, isFetching } = useGetAllAuctionsQuery({
    page,
    search: debouncedSearch,
  });
  const loading = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  const getAuctionStatus = (auction) => {
  const now = new Date();
  const auctionDate = new Date(auction.auctionDate);

  if (auction.alternativeDate) {
    const alternativeDate = new Date(auction.alternativeDate);

    if (now < auctionDate) return "Upcoming";
    if (now >= auctionDate && now < alternativeDate) return "Postponed";
    if (now >= alternativeDate) return "Completed";
  }

  if (now < auctionDate) return "Upcoming";
  return "Completed";
};

  return (
    <div className="flex flex-col lg:gap-10 md:gap-6 gap-4 bg-white rounded-xl lg:p-4 p-3 h-full">
      <div className="flex justify-between items-center">
        <p className="text-[#05004E] font-semibold lg:text-[1.8rem] md:text-[1.4rem] text-[1.2rem]">
          Auctions
        </p>
        <div className="flex  items-center">
          <NavLink
            to={"/auctions/add-auction"}
            className="lg:w-[12rem] md:w-[10rem] w-max bg-[#00643b] text-center lg:py-3 md:py-2 md:px-0 px-2 py-1.5 lg:text-[1rem] md:text-[.9rem] text-[.75rem] md:rounded-xl rounded-lg font-medium text-white"
          >
            + Add New
          </NavLink>
        </div>
      </div>
      <div className=" flex flex-col gap-4 w-full">
        <div className=" flex justify-end w-full">
          <input
            type="search"
            placeholder="Search by title or date..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setPage(1);
            }}
            className="border-2 rounded-xl border-[#05004e40] md:p-3 p-2 outline-none md:w-[24rem] md:text-[1rem] text-[.8rem] w-[18rem]"
          />
        </div>
        {isLoading || isFetching ? (
          <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-3 gap-2 ">
            {loading.map((i) => (
              <div
                key={i}
                className="bg-[#EFEFEF] animate-pulse p-3 rounded-xl flex flex-col gap-1.5"
              >
                <p className=" bg-[#97979750] h-5 rounded-lg animate-pulse w-[90%]"></p>
                <p className=" bg-[#97979750] h-4 rounded-lg animate-pulse w-[70%]"></p>
                <p className=" bg-[#97979750] h-4 rounded-lg animate-pulse w-[50%]"></p>
              </div>
            ))}
          </div>
        ) : (
          data && (
            <>
              {data?.totalPages === 0 ? (
                <div className=" text-center w-full lg:text-[3rem] md:text-[2rem] text-[1.4rem] font-semibold text-[#05004E]">
                  No Auction Found
                </div>
              ) : (
                <div className=" grid lg:grid-cols-2 grid-cols-1 lg:gap-3 gap-2">
                  {data?.auctions?.map((auction) => (
                    <div
                      key={auction?._id}
                      className="bg-[#DEE9E4] lg:p-3 p-2 rounded-xl flex flex-col lg:gap-1.5 gap-1 lg:text-sm text-[12px]"
                    >
                      <div className=" flex justify-between items-center gap-2">
                          <span className="text-[#00643B] capitalize font-medium xl:text-[1.4rem] lg:text-[1.2rem] text-[1.1rem]">
          {getAuctionStatus(auction)}
        </span>
                        <NavLink to={`/auctions/update-auction/${auction?._id}`}>
                          <HiDotsVertical className=" md:size-7 size-5 " />
                        </NavLink>
                      </div>
                      <p className=" capitalize">{auction?.title}</p>
                      <p>
                        Auction Date: {formatToLongDate(auction?.auctionDate)}
                      </p>
                      {auction?.alternativeDate && (

                        <p>
                        Alternative Date: {formatToLongDate(auction?.alternativeDate)}
                      </p>
                      )}
                    </div>
                  ))}
                </div>
              )}
              <div className=" flex justify-between items-center">
                <div className=" text-[#0000004f]">
                  Showing record page {data?.currentPage} 0f {data?.totalPages}
                </div>
                <div className=" flex items-center gap-4">
                  <div
                    onClick={handlePrev}
                    disabled={page === 1}
                    className={`bg-[#02643B1F] p-2 text-[#00643b] rounded-xl ${
                      page === 1
                        ? " cursor-not-allowed opacity-50"
                        : "cursor-pointer"
                    }`}
                  >
                    <IoIosArrowBack className="size-6" />
                  </div>
                  {data?.currentPage}
                  <div
                    onClick={handleNext}
                    disabled={page === data?.totalPages}
                    className={`bg-[#02643B1F] p-2 text-[#00643b] rounded-xl ${
                      page === data?.totalPages
                        ? " cursor-not-allowed opacity-50"
                        : "cursor-pointer"
                    }`}
                  >
                    <IoIosArrowForward className="size-6" />
                  </div>
                </div>
              </div>
            </>
          )
        )}
      </div>
      {error && (
        <p className=" text-red-500 text-center md:text-[1rem] text-sm bg-red-100 p-2 rounded-lg">
          {error?.data?.message}
        </p>
      )}
    </div>
  );
};

export default Auctions;
